var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { IAnalyticsDataSourceType, IEventsDataSourceType, inject, injectable } from '@serviceos-rn/core';
import { TipConfig } from '../../TipConfig';
import { TipEventNames } from '../../Domain/DTOs/Tip/TipEvent';
let TipEventsRepository = class TipEventsRepository {
    constructor(eventsDataSource, analyticsDataSource) {
        this.eventsDataSource = eventsDataSource;
        this.analyticsDataSource = analyticsDataSource;
    }
    sendTipEvent(event, data) {
        var _a;
        return this.analyticsDataSource.sendEvent(TipConfig.moduleName, event, {
            resource_type: 'tip',
            resource_id: (_a = data === null || data === void 0 ? void 0 : data.id) === null || _a === void 0 ? void 0 : _a.toString(),
            payload: {
                choice: data
            }
        });
    }
    sendDidTipEvent(choice) {
        this.eventsDataSource.sendEvent(TipConfig.moduleName, {
            module: TipConfig.moduleName,
            event: TipEventNames.didTip,
            data: { choice }
        });
        this.sendTipEvent(TipEventNames.didTip, choice);
        return choice;
    }
    sendModuleLoaded() {
        this.eventsDataSource.sendEvent(TipConfig.moduleName, {
            module: TipConfig.moduleName,
            event: TipEventNames.didModuleLoaded,
            data: {
                success: true
            }
        });
        return true;
    }
    sendDidFinishTipping(choice) {
        this.eventsDataSource.sendEvent(TipConfig.moduleName, {
            module: TipConfig.moduleName,
            event: TipEventNames.didFinishTipping,
            data: {
                success: true,
                choice
            }
        });
        this.sendTipEvent(TipEventNames.didFinishTipping, choice);
        return choice;
    }
};
TipEventsRepository = __decorate([
    injectable({
        type: 'singleton'
    }),
    __param(0, inject(IEventsDataSourceType)),
    __param(1, inject(IAnalyticsDataSourceType)),
    __metadata("design:paramtypes", [Object, Object])
], TipEventsRepository);
export { TipEventsRepository };
